export default "__VITE_ASSET__Ku3BXoMn__";